class Timeline {
    constructor(container) {
        this.container = container;

        this.itemAttribute = 'data-timeline-item';
        this.triggerAttribute = 'data-timeline-trigger';

        this.items = Array.from(this.container.querySelectorAll(`[${this.itemAttribute}]`));
        this.triggers = Array.from(this.container.querySelectorAll(`[${this.triggerAttribute}]`));

        if (this.items.length === 0 || this.triggers.length === 0) return;

        this.currentItem = this.items[0];

        this.previousItemKeyword = 'prev';
        this.nextItemKeyword = 'next';

        this._init();
    }

    _init() {
        this._hideAllItems();
        this._showItem(this.currentItem);
        this._createTriggerListeners();
    }

    _createTriggerListeners() {
        this.triggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                let itemKey = trigger.getAttribute(this.triggerAttribute);

                if (itemKey === this.previousItemKeyword) {
                    this.currentItem = this._getPreviousItem();
                } else if (itemKey === this.nextItemKeyword) {
                    this.currentItem = this._getNextItem();
                } else {
                    this.currentItem = this.items.find((item) => item.getAttribute(this.itemAttribute) === itemKey);
                }

                this._hideAllItems();
                this._showItem(this.currentItem);

                this._setActiveTriggerForItem(this.currentItem);

                // Trigger resize event so JFS scroll animation still trigger properly after timeline clicks
                var event = document.createEvent('HTMLEvents');
                event.initEvent('resize', true, false);
                window.dispatchEvent(event);
            });
        });
    }

    _getPreviousItem() {
        const currentItemIndex = this.items.indexOf(this.currentItem);

        if (this.items[currentItemIndex - 1]) {
            return this.items[currentItemIndex - 1];
        } else {
            return this.items[this.items.length - 1];
        }
    }

    _getNextItem() {
        const currentItemIndex = this.items.indexOf(this.currentItem);

        if (this.items[currentItemIndex + 1]) {
            return this.items[currentItemIndex + 1];
        } else {
            return this.items[0];
        }
    }

    _setActiveTriggerForItem(activeItem) {
        const itemKey = activeItem.getAttribute(this.itemAttribute);
        const activeTrigger = this.triggers.find((trigger) => trigger.getAttribute(this.triggerAttribute) == itemKey);

        this.triggers.forEach((trigger) => {
            trigger.classList.remove('link-primary', 'text-xl');
            trigger.classList.add('link-primary-light');
        });

        activeTrigger.classList.remove('link-primary-light');
        activeTrigger.classList.add('link-primary', 'text-xl');
    }

    _hideAllItems() {
        this.items.forEach((item) => {
            item.classList.add('hidden');
        });
    }

    _showItem(item) {
        item.classList.remove('hidden');
    }
}

const initTimelines = () => {
    const containers = Array.from(document.querySelectorAll('[data-timeline]'));

    containers.forEach((container) => {
        new Timeline(container);
    });
};

initTimelines();
